<template>
	
		<div id="app">
		
		  <!--<transition :name="transitionName"> 
	　　　　　　<router-view class="Router"></router-view>
	　　　　</transition>-->
			<!--<router-view ></router-view>-->
			<keep-alive>
			    <router-view v-if="$route.meta.keepAlive" exclude="feilei_dp"></router-view>
			</keep-alive>
			<router-view v-if="!$route.meta.keepAlive"></router-view>

		</div>

	
</template>

<script>

	export default {
		name: 'index',
		data() {
			return {
				url:'131',
				reload:this.reload,
				transitionName: 'slide-left'  // 默认动态路由变化为slide-right
			}
		},
		methods: {  
//		
		},
		watch: {//使用watch 监听$router的变化
		    $route(to, from) {
		      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
		      if(to.meta.index > from.meta.index){
		        //设置动画名称
		        this.transitionName = 'slide-left';
		      }else{
		        this.transitionName = 'slide-right';
		      }
		    }
		}
	}
</script>
<style lang="scss">

.Router {
     position: absolute;
     width: 100%;
     transition: all .5s ease;
}


	* {
		padding: 0;
		margin: 0;
	}
	body{
		background:#FAFAFA!important;
		height: auto!important;
		/*position:fixed;*/
		/*width:100%;*/
	}
	.router-link-exact-active div {
		color: #63cc8a!important;
	}
	html {
		font-size: 98px!important;
	}
/*	/*
	body {
		font-size: 14px;
		font-size: 1.4rem;
	}
	
	p {
		font-size: 14px;
		font-size: 1.4rem;
	}*/
	ul li{
		list-style-type:none;  
	}
	a{
		text-decoration: none;
		color: #1A1A1A;
		
	}
	i{
		font-style: normal;
	}
	#app {
		/*font-family: 'MicrosoftYaHeiUI';*/
		font-family:"微软雅黑";
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #1A1A1A;
		position: relative;
		left:0;
		right:0;
		margin:auto;
		font-size:14px;
		box-sizing: border-box;
	}
	#box{
		background: white;
	}
	.el-dialog__header{
		border-bottom:1px solid #E4E5ED;
		text-align: left;
		font-size:16px;
	}
	.address_big .el-dialog--center .el-dialog__body{
		padding-left:0!important;
		padding-right:0!important;
	}
	.el-input__inner{
		height:32px!important;
		line-height: 32px!important;
	}
	.el-input__suffix{
		top:2px!important;
		line-height: 32px!important;
	}
	.el-input__icon{
		line-height: 32px!important;
		top:0px!important;
	}
	.boxx11 textarea{
		height:70px;
	}
	.sy_big .el-loading-mask{
		width:100px;
		height:100px;
		margin:auto;
		top:-300px;
	}
	.ell_box{
		overflow : hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		word-break: break-all;
	}
	.sp .el-loading-mask{
		width:100px;
		height:100px;
		margin:auto;
		top:500px;
	}
	.sps .el-loading-mask{
		width:100px;
		height:100px;
		margin:auto;
	}
	.fwb{
		min-height:400px;
		padding-top:16px;
		width:100%;
		text-align: left;
		p{
			width:100%;
			// line-height: 0!important;
			img{
				width:100%!important;
				height:auto!important;
				float: left
			}
		}
	}
	.fy .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:rgb(243, 162, 81)!important;
	}
	.fy .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
		color:white!important;
	}
	.fy .el-pagination.is-background .el-pager li:not(.disabled):hover{
		color:rgb(243, 162, 81)!important;
	}
	.flexss{
		display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
		display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
		display: -ms-flexbox;      /* TWEENER - IE 10 */
		display: -webkit-flex;  
	}
	.input{
		.el-input__inner{
			background:#EDC76B!important;
			color:white!important;
			border:none;
			outline: none;
		}
	}
	.fwb #content{
		width:100%!important;
	}
	.fwb img{
		width:100%;
	}
	.sale_price{
		display: flex;
		align-items: center;
	}
	.ivu-checkbox-checked .ivu-checkbox-inner{
		background: #F3A251!important;
		border-color: #F3A251!important ;
		border-radius: 50%;
		outline: none;
	}
	.ivu-checkbox-inner{
		border-radius: 50%!important;
	}
	.el-form-item__label{
		padding: 0 14px 0 0!important;
	}
	.center_nav .el-input__inner{
		border:none;
		width:130px;
		text-align: center;
	}
	.el-select-dropdown__item.selected{
		color:#F3A251!important;
	}
	.center_nav .el-input__inner::-webkit-input-placeholder {
        color:#0A1132;
    }
	.center_nav .el-input__inner::-moz-input-placeholder {
	    color:#0A1132;
	}
	.center_nav .el-input__inner::-ms-input-placeholder {
	    color:#0A1132;
	}
</style>